module.exports = "/assets/data/b3e73014bb0ced6250aeff30391f12cb-ST4.data.json";